import { render, staticRenderFns } from "./FolderSettings.vue?vue&type=template&id=0ef4022a"
import script from "./FolderSettings.vue?vue&type=script&lang=js"
export * from "./FolderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef4022a')) {
      api.createRecord('0ef4022a', component.options)
    } else {
      api.reload('0ef4022a', component.options)
    }
    module.hot.accept("./FolderSettings.vue?vue&type=template&id=0ef4022a", function () {
      api.rerender('0ef4022a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FolderSettings.vue"
export default component.exports